'use client';

import Image , { StaticImageData } from 'next/image';
import React from 'react';

interface CallToActionBannerProps {
  fullWidth?: boolean;
  callToActionTitle?: string;
  callToActionTitleTextColor?: string;
  callToActionButtonText: string;
  callToActionDescription: string;
  callToActionDescriptionTextColor: string;
  backgroundColor?: string;
  callToActionButtonTextColor?: string;
  callToActionButtonBackgroundColor?: string;
  callToActionButtonHoverTextColor?: string;
  callToActionButtonHoverBackgroundColor?: string;
  imageWidth?: number;
  imageHeight?: number;
  imageSrc?: StaticImageData;
  imageAlt?: string;
  height?: string;
  padding?: string;
  maxContentWidth?: string;
  borderColor?: string;
  borderWidth?: string;
}

const CallToActionBanner: React.FC<CallToActionBannerProps> = ({
  fullWidth = false,
  callToActionTitle,
  callToActionTitleTextColor,
  callToActionButtonText,
  callToActionDescription,
  callToActionDescriptionTextColor ='text-black',
  backgroundColor = 'bg-gray-200',
  callToActionButtonTextColor = 'text-white',
  callToActionButtonBackgroundColor = 'bg-blue-500',
  callToActionButtonHoverTextColor = 'text-white',
  callToActionButtonHoverBackgroundColor = 'bg-blue-700',
  imageWidth = 200,
  imageHeight = 200,
  imageSrc,
  imageAlt = 'Banner Image',
  height = 'h-auto',
  padding = 'p-6',
  maxContentWidth = 'max-w-6xl',
  borderColor = 'border-transparent',
  borderWidth = 'border-0'
}) => {
  return (
    <div className={`${fullWidth ? 'w-full' : 'max-w-full'} ${backgroundColor} ${borderColor} ${borderWidth} border`}>
      <div
        className={`mx-auto ${maxContentWidth} ${padding} ${height} flex flex-col md:flex-row items-center justify-between`}
      >
        {imageSrc && (
          // <div className="mb-4 md:mb-0 md:mr-6">
          <div className="mr-6">
              <Image src={imageSrc} alt={imageAlt} width={imageWidth} height={imageHeight} className="rounded-lg" />
          </div>
        )}
         <div className="flex-1 text-center md:text-left">
          {callToActionTitle && <h2 className={`text-xl font-bold mb-2 ${callToActionTitleTextColor}`}>{callToActionTitle}</h2>}
          <p className={`text-lg font-semibold  whitespace-pre-line ${callToActionDescriptionTextColor}`}>{callToActionDescription}</p>
        </div>
        <a  href="/contact"
        // >
        // <button
          className={`mt-4 md:mt-0 px-6 py-2 rounded-lg font-medium transition-colors duration-300 ${callToActionButtonTextColor} ${callToActionButtonBackgroundColor} hover:${callToActionButtonHoverTextColor} hover:${callToActionButtonHoverBackgroundColor}`}
        >
          {callToActionButtonText}
        {/* </button> */}
        </a>
      </div>
    </div>
  );
};

export default CallToActionBanner;
